module.exports = __webpack_public_path__ + "static/media/profile-user.ca10b946.png";